import { ecmUnavailableHeader } from '../../../../../../utils/constants/ecm.constants'

export const AttachmentUploadingSuccessHeader = 'Success!'
export const AttachmentUploadingSuccessToastMessage =
  'Uploading of document(s) has been successfully processed. ' +
  'Please refer to Attachments Section of the certificate to view the status of the document(s).'

export const AttachmentUploadingErrorHeader = ecmUnavailableHeader
export const AttachmentUploadingErrorToastMessage =
  `Something went wrong while accessing ECM. Please try and save the ECM TIC documents once ECM is back on-line (see status bar). ` +
  `File(s) will be temporarily saved in GMAWB File Storage. To retrigger ECM, please navigate to the Pending Document list in the Certificate Management Module.`

export const WithdrawalAttachmentUploadingSuccessHeader = 'Certificate Withdrawn Successfully'
export const WithdrawalAttachmentUploadingSuccessMessage =
  'Certificate has been successfully withdrawn.'

export const PendingWithdrawalSuccessHeader = 'Certificate Withdrawal Pending'
export const PendingWithdrawalSuccessMessage =
  'Certificate details updated. The certificate will remain active until the scheduled withdrawal.'

export const ActiveAttachmentUploadingSuccessHeader = 'Certificate Activated Successfully'
export const ActiveAttachmentUploadingSuccessMessage =
  "Your certificate is now 'Active', and all attachments have been successfully uploaded and linked to both UL Workbench and the ECM TIC."
